import { render, staticRenderFns } from "./dongHuaYinBiao.vue?vue&type=template&id=133fa7f7&scoped=true&"
import script from "./dongHuaYinBiao.vue?vue&type=script&lang=js&"
export * from "./dongHuaYinBiao.vue?vue&type=script&lang=js&"
import style0 from "./dongHuaYinBiao.vue?vue&type=style&index=0&id=133fa7f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133fa7f7",
  null
  
)

export default component.exports